import { trackByEvent } from '../../../tracking/services';
import { COMPONENT_TYPE } from '../../../tracking/constant';
import { PRODUCT_OVERVIEW_PAGE_TRACKING_EVENTS, TFAQClick, TFAQScrollToBottom, TPageGetStarted, } from './index'
import i18n, { defaultLang } from '@src/i18n';
export const trackGetStarted = (buttonNumber: number) => {
    try {
        const trackData: TPageGetStarted = {
            component_name: 'courier app overview',
            component_id: `BUTTON_${buttonNumber}`,
            component_type: PRODUCT_OVERVIEW_PAGE_TRACKING_EVENTS.GET_STARTED.component_type as COMPONENT_TYPE,
            eventCategory: '',
            language: i18n.language || defaultLang,
            country: '',
            form_action: 'submit'
        }
        trackByEvent<TPageGetStarted>(PRODUCT_OVERVIEW_PAGE_TRACKING_EVENTS.GET_STARTED.event, trackData)
    } catch (error) {
        console.log('trackVideoStart error', error);
    }
}


export const trackFAQClick = (faqTitle: string, faqIndex: number) => {
    try {
        const { faq_action, component_type, event, pageGroup } = PRODUCT_OVERVIEW_PAGE_TRACKING_EVENTS.FAQ_OPEN
        const trackData: TFAQClick = {
            component_name: `${faqTitle}`,
            component_id: `${faqIndex}`,
            component_type: component_type as COMPONENT_TYPE,
            eventCategory: '',
            language: i18n.language || defaultLang,
            country: '',
            faq_action,
            pageGroup
        }
        trackByEvent<TFAQClick>(event, trackData)
    } catch (error) {
        console.log('trackFAQClick error', error);
    }
}

export const trackScrollToBottom = () => {
    try {
        const { component_type, event, pageGroup } = PRODUCT_OVERVIEW_PAGE_TRACKING_EVENTS.FAQ_SCROLL_TO_BOTTOM
        const trackData: TFAQScrollToBottom = {
            component_name: ``,
            component_type: component_type as COMPONENT_TYPE,
            eventCategory: '',
            language: i18n.language || defaultLang,
            country: '',
            pageGroup
        }
        trackByEvent<TFAQScrollToBottom>(event, trackData)
    } catch (error) {
        console.log('trackScrollToBottom error', error);
    }
}
